import { graphql } from "../generated";

export const GetEvaluations = graphql(
  `
    query GetEvaluations($filters: GetEvaluationsFilter!) {
      getEvaluations(filters: $filters) {
        __typename

        ... on GenericException {
          ...BaseException
        }

        ... on UserInputException {
          ...UserInputException
        }

        ... on PaginatedEvaluations {
          items {
            ...Evaluation
          }
          pageInfo {
            total
          }
        }
      }
    }
  `
);
